import { type HighlightResult } from 'highlight.js';

export const openingTag = /{% mark (green|yellow|red) %}/g;
export const closingTag = /{% mark %}/g;

class HLJSHighlighting {
  'after:highlightElement'({ result, el }: { result: HighlightResult; el: Element }) {
    el.innerHTML = result.value
      .replace(openingTag, '<mark class="$1">')
      .replace(closingTag, '</mark>');
  }
}

export default HLJSHighlighting;
